import { API } from "aws-amplify";

export default async function generateBarcode(id) {
  if (id) {
    return await API.get("otzcards", `${id}/barcodes`);
  }
}
